export default "__VITE_ASSET__BXDMmdrr__"